import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateShowFolderDocument } from './create.generated';

export const useCreateShowFolder = (options: ApiOptions<typeof CreateShowFolderDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(CreateShowFolderDocument, {
    ...useNotifications(CreateShowFolderDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.show_folders.create_success'),
    }),
    ...options,
  });
};
